var map = {
	"./about": 4,
	"./about.jpg": 4,
	"./academy/qr": 5,
	"./academy/qr.png": 5,
	"./address/google": 6,
	"./address/google.svg": 6,
	"./address/waze": 7,
	"./address/waze.svg": 7,
	"./eraf_meemo_en": 8,
	"./eraf_meemo_en.svg": 8,
	"./eraf_meemo_lv": 9,
	"./eraf_meemo_lv.svg": 9,
	"./eraf_sunstar_en": 10,
	"./eraf_sunstar_en.svg": 10,
	"./eraf_sunstar_en_2023": 11,
	"./eraf_sunstar_en_2023.svg": 11,
	"./eraf_sunstar_lv": 12,
	"./eraf_sunstar_lv.svg": 12,
	"./eraf_sunstar_lv_2023": 13,
	"./eraf_sunstar_lv_2023.svg": 13,
	"./fav/academy_favicon": 14,
	"./fav/academy_favicon.ico": 30,
	"./fav/academy_favicon.png": 14,
	"./fav/meemo_favicon": 15,
	"./fav/meemo_favicon.ico": 31,
	"./fav/meemo_favicon.png": 15,
	"./fav/optiv_favicon": 16,
	"./fav/optiv_favicon.ico": 32,
	"./fav/optiv_favicon.png": 16,
	"./fav/sunstar_favicon": 17,
	"./fav/sunstar_favicon.ico": 33,
	"./fav/sunstar_favicon.png": 17,
	"./footer_bg": 18,
	"./footer_bg.png": 18,
	"./logo": 19,
	"./logo.svg": 19,
	"./services": 20,
	"./services.jpg": 20,
	"./social/facebook": 21,
	"./social/facebook.png": 21,
	"./social/linkedin": 22,
	"./social/linkedin.png": 22,
	"./social/tiktok": 23,
	"./social/tiktok.png": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;